
	// @ts-nocheck
	import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
	import Loading from '@/components/Loading.vue';
	import DualButtonModal from '@/components/modals/DualButtonModal.vue';
	import SearchModal from '@/components/modals/SearchModal.vue';
	import PatientRow from '@/components/patient-list/PatientRow.vue';
	import { Observer } from 'mobx-vue';
	import { autorun, IReactionDisposer } from 'mobx';
	import { Order, Pagination, Patient } from '@/store/engine/openapi/generated';
	import { OrderWithPatient } from '@/store/DoctorStore';
	import OrderRow from '@/components/patient-list/OrderRow.vue';
	import UtilsStore from '@/store/utilsStore';

	@Observer
	@Component({
		components: { SearchModal, DualButtonModal, Loading, PatientRow, OrderRow },
		filters: {
			fixedLength(val: string) {
				return val.length >= 43 ? val.slice(0, 40) + '...' : val;
			}
		}
	})
	export default class OrderTable extends Vue {
		@Prop() private privacy = false;
		@Prop() private orders: OrderWithPatient[];

		private patientChosen = false;
		private onScrollEvent() {
			return;
		}

		activated() {
			this.patientChosen = false;
		}

		public async patientFlowSkip(patient: OrderWithPatient) {
			this.$emit('patientClick', patient);
		}
	}
